import { Game, GameState } from "@aura-frontend/omnibus-az-client";

import { getEventTimes } from "@/utils/eventUtils";

import { formatGameStartTime } from "../../../utils/formatGameStartTime";

type GameModeInfoProps = {
  game: Game;
  gameState: GameState;
};

export const GameModeInfo = ({ game, gameState }: GameModeInfoProps) => {
  const displayName = game.displayName;
  const startTime = getEventTimes(game).startTime;

  return (
    <div className="mt-5 mb-5 w-full space-y-2">
      <div className="flex flex-col">
        <span className="font-bold text-text-light">Game:</span>
        <span className="text-text-light mb-2">{displayName}</span>
      </div>

      <div className="flex flex-row gap-2">
        <span className="font-bold text-text-light">Started at:</span>
        <span className="text-text-light">
          {formatGameStartTime(Number(startTime))}
        </span>
      </div>

      <div className="flex flex-row gap-2">
        <span className="font-bold text-text-light">Inning:</span>
        <span className="text-text-light">
          {gameState.inning.integer} - {gameState.inning.half}
        </span>
      </div>
    </div>
  );
};
